/*       */

import { name } from 'app/utils/designer/form/settings/common/commonBase';
import { onLoad, onChange, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';

const panels = [
    {
        header: 'Base',
        children: [
            name,
            { type: 'boolean', properties: { label: 'Show name', name: 'properties.showName' } },
            { type: 'boolean', properties: { label: 'Show GPS Coordinates', name: 'properties.showGPSCoords' } },
            { type: 'boolean', properties: { label: 'Show Address', name: 'properties.showAddress' } },
            { type: 'boolean', properties: { label: 'Allow pin to be moved on map', name: 'properties.allowPinDrag' } },
        ],
    },
    {
        header: 'Events',
        children: [onLoad, onChange, isDisabled],
    },
    {
        header: 'Styles',
        children: [flexGrow],
    },
    {
        header: 'Helpers',
        children: [help],
    },
];

export default {
    defaults: { serialize: true, readOnly: false, showName: true, showGPSCoords: true, showAddress: true, allowPinDrag: true },
    panels: settingValues => panels,
};
